export default __webpack_public_path__ + "static/media/IMG_0026_7_11zon.0691ab79.jpg";